import React from 'react';
import PropTypes from 'prop-types';
import { Col } from '@app/ui';
import classNames from '@app/ui/sports-components/utils/classNames';
import { getSponsorActiveAtPlacement } from '../utils/getActiveOnboardingInstances';

import './RPLogo.scss';

const RPLogo = ({ sp, i, leftOvers, rowIndex, placementActive = true }) => {
    const logo = sp.logos && sp.logos.length > 0 ? sp.logos[0].url : null;
    const showLeftOvers = i == 2 && rowIndex == 2 && leftOvers;
    const sponsorImageClassnames = classNames('gds-sponsors__image', {
        '-color-bg-white': getSponsorActiveAtPlacement(sp) && placementActive,
        'grayed-background':
            !getSponsorActiveAtPlacement(sp) || !placementActive,
    });
    const imgClassnames = classNames({
        'grayed-image': !getSponsorActiveAtPlacement(sp),
    });

    return (
        <Col md={8} key={sp.id}>
            <div className={sponsorImageClassnames}>
                {!showLeftOvers && (
                    <img
                        src={logo}
                        height="100%"
                        width="100%"
                        className={imgClassnames}
                    />
                )}
                {showLeftOvers && (
                    <div className="gds-leftover-number  gds-text--body-xs gds-text--regular -p-t-1">
                        +{leftOvers}
                    </div>
                )}
            </div>
        </Col>
    );
};

RPLogo.propTypes = {
    sp: PropTypes.object,
    i: PropTypes.number,
    leftOvers: PropTypes.number,
    rowIndex: PropTypes.number,
    placementActive: PropTypes.bool,
};

export default RPLogo;
